<app-action-button
    (addEvent)="create()"
    [isDeleteAction]="isDeleteAction"
    (deleteEvent)="openConfirm($event)"
    [hidden]="!authorizationService.canCreateOIDCAudience()"
>
</app-action-button>

<app-loading-indicator [isLoading]="isLoading" class="load-indicator" *ngIf="isLoading" id="oidcAudiencesPage"></app-loading-indicator>
<div class="area data-table" id="ItemsArea">
    <app-noitems
        (clickEmit)="create()"
        [image]="'No_Clients'"
        [isEmpty]="showNoData"
        [typeName]="'oidc audiences.'"
    ></app-noitems>

    <app-data-table
        (filterChanged)="filterChanged.bind(this)"
        *ngIf="filterApplied || (oidcAudiences.length > 0 && !isLoading) || filterHasChanged || changedPage"
        [columnDefinitions]="columnDefs"
        [columnFilters]="columnFilters"
        [rowData]="oidcAudiences"
        [tableId]="'oidc-audiences'"
        [toggleItem]="toggle.bind(this)"
        [toggleAll]="toggleAll.bind(this)"
        [deleteItem]="deleteSingleItem.bind(this)"
        [openItem]="open.bind(this)"
    ></app-data-table>
</div>
